// Client-side write path for user_profiles.prefs — durable per-user UI facts
// (first use: the NAPLAN year-level override). Reads happen server-side via
// getProfile; this helper merges one key into the JSONB from the browser.
// Read-modify-write is fine here: prefs are single-user, low-frequency taps.
import { createClient } from "@/lib/supabase";

export async function saveUserPref(uid: string, key: string, value: unknown): Promise<void> {
  const supabase = createClient();
  const { data } = await supabase
    .from("user_profiles")
    .select("prefs")
    .eq("user_id", uid)
    .maybeSingle();
  const prefs = { ...((data?.prefs as Record<string, unknown>) ?? {}), [key]: value };
  const { error } = await supabase.from("user_profiles").update({ prefs }).eq("user_id", uid);
  if (error) throw error;
}
